/**
 * Scroll-triggered reveals.
 *
 * The hidden state is applied only once this script has run and stamped the
 * document — if the script fails to load or throws, nothing is ever hidden and
 * the page reads normally. Content that depends on JavaScript to become visible
 * is a content-invisible-forever bug waiting to happen.
 *
 * prefers-reduced-motion is handled in CSS: the duration tokens collapse to 0ms
 * and elements land in place with no travel. The observer still runs so the
 * end state is identical either way.
 */
(function () {
  var items = document.querySelectorAll('[data-reveal]');
  if (!items.length) return;

  document.documentElement.setAttribute('data-reveal-ready', '');

  // No IntersectionObserver means no reveal — show everything immediately.
  if (!('IntersectionObserver' in window)) {
    for (var i = 0; i < items.length; i++) items[i].setAttribute('data-revealed', '');
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-revealed', '');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.01 }
  );

  items.forEach(function (item) {
    observer.observe(item);
  });
})();
